<template>

  <div>
    
    
    <header class="topbar">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <router-link class="navbar-brand" to="/">W3 Website Builder</router-link>
        <ul class="ml-auto navbar-nav" >
          <router-link class="nav-link" href="#" to="/logout">Logout</router-link>
        </ul>
      </nav>
    </header>


    <div class="container">

      <div class="my-3">
        <h1>New Project</h1> 
      </div>

      <form method="post" @submit.prevent="onSubmit">

        <div class="form-group">
          <label>Name</label>
          <input v-model="project.name" type="text" class="form-control" required>
        </div>


        <!-- image upload - tiny inline preview -->
        <!-- <div class="form-group">
          <label>Imagem</label>
          <div class="d-flex">
            <div class="custom-file">
              <input type="file" class="custom-file-input" @change="onFileChange($event,project,'favicon')">
              <label class="custom-file-label">Upload</label>
            </div>
            <div class="flex-shrink-0">
              <img v-if="project.favicon" :src="project.favicon" class="img-thumbnail" style="max-height:38px">
            </div>
            <button v-if="project.favicon" class="close p-2" @click="project.favicon=''"><span>&times;</span></button>
          </div>
        </div> -->


        <div class="form-group">
          <label>Template</label>
          <div class="card-deck">
            
            <div class="card border-primary">
              <!-- <img class="card-img-top" alt="Card image cap"> -->
              <div class="card-img-top" />
              <div class="card-body">
                <h5 class="card-title">No template</h5>
                <p class="card-text">Start with a blank page.</p>
              </div>
            </div>
            <div class="card soon">
              <img class="card-img-top" src="/images/templates/gardenio-garden--landscape-design-moto-cms-3-template_96157-original.webp" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title">Template 1</h5>
                <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </div>
            </div>
            <div class="card soon">
              <img class="card-img-top" src="/images/templates/grand-vector-design-studio-multipurpose-website-template_58530-original.webp" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title">Template 2</h5>
                <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </div>
            </div>
            <div class="card soon">
              <img class="card-img-top" src="/images/templates/mofshop-minimalist-store-with-page-builder-joomla-template_96093-original.webp" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title">Template 3</h5>
                <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </div>
            </div>
          </div>
        </div>



        <button type="submit" class="btn btn-primary">Continue</button>
        <router-link class="btn btn-light" to="/">Cancel</router-link>


      </form>

    </div>
  </div>


</template>
<script>

  import componentFunctions from '../mixin.components.js'
  import axios from 'axios';
  import Vue from 'vue'

  import gHeader from '../components/gHeader.vue'
  export default {
    name: 'project-form',
    components:{'g-header':gHeader},
    mixins:[componentFunctions],
    data() {
      return {
        project:{
          name:'',
          favicon:'',
        },
      }
    },
    methods:{

      onSubmit(){

        var endpoint = '/api/projects';

        axios({
          method: 'post',
          url: endpoint,
          data: this.project
        }).then((res) => {

          this.$router.push('/project/'+res.data.id);

        });

      },

    },
    mounted(){
    }

  }



</script>

<style scoped>
  .card.soon .card-img-top,
  .card.soon .card-body {
    opacity: .3;
  }
  .card.soon:after {
    content:"soon";
    position: absolute;
    top:40%; 
    left:50%;
    padding:5px 10px;
    background:#333;
    color:#fff;
    font-weight: bold;
    transform: translate(-50%,-50%) rotate(-20deg);
  }
  .card-img-top { 

    height: 200px; object-fit: cover;
  }

</style>
